import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { BreadcrumbService } from '../services/breadcrumb.service';

import { MenuItem } from 'primeng/api';

@Component({
    selector: '[theme-breadcrumb]',
    templateUrl: './theme.breadcrumb.component.html',
    standalone: false
})
export class ThemeBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];

    constructor(private breadcrumbService: BreadcrumbService) {
        this.subscription = this.breadcrumbService.Breadcrumbs.subscribe(response => {
            this.items = response;
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
